import * as requestFromServer from "./businessesCrud";
import {businessesSlice, callTypes} from "./businessesSlice";

const {actions} = businessesSlice;

export const fetchBusinesses = queryParams => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));

 // check for approval status and update queryParams filter 
 const status = window.location.pathname.split("/")[2];
 if(status==="approved") { queryParams.filter.status='0'; }
 else if(status==="pending")  { queryParams.filter.status='1'; }
 else if(status==="rejected") { queryParams.filter.status='2'; }
 else if(status==="reported") { queryParams.filter.status='3'; }
 else if(status==="draft")    { queryParams.filter.status='5'; }
 else if(!status || status === "all") {
   if (queryParams.filter && (queryParams.filter.status === undefined || queryParams.filter.status === '0' || queryParams.filter.status === 0)) {
     queryParams.filter.status = -1;
   }
 }
  return requestFromServer
    .findBusinesses(queryParams)
    .then(response => {
		const { totalCount, entities } = response.data
		dispatch(actions.businessesFetched({totalCount, entities}));
    })
    .catch(error => {
      error.clientMessage = "Can't find businesses";
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
}; 

export const fetchBusiness = id => dispatch => {
  if (!id) {
    return dispatch(actions.businessFetched({ businessForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getBusinessById(id)
    .then(response => {
      const business = response.data;
      dispatch(actions.businessFetched({ businessForEdit: business }));
    })
    .catch(error => {
      error.clientMessage = "Can't find business";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteBusiness = id => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteBusiness(id)
    .then(response => {
      dispatch(actions.businessDeleted({ id }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete business";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createBusiness = businessForCreation => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createBusiness(businessForCreation)
    .then(response => {
      const business = response.data.business || response.data.data || response.data;
      dispatch(actions.businessCreated({ business }));
      return business;
    })
    .catch(error => {
      error.clientMessage = "Can't create business";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateBusiness = business => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateBusiness(business)
    .then(() => {
      dispatch(actions.businessUpdated({ business }));
    })
    .catch(error => {
      error.clientMessage = "Can't update business";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateBusinessesStatus = (ids, status, message, type) => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForBusinesses(ids, status, message, type)
    .then(() => {
      dispatch(actions.businessesStatusUpdated({ ids, status }));
    })
    .catch(error => {
      error.clientMessage = "Can't update businesses status";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteBusinesses = ids => dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteBusinesses(ids)
    .then(() => {
      dispatch(actions.businessesDeleted({ ids }));
    })
    .catch(error => {
      error.clientMessage = "Can't delete businesses";
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
